// Same allowlist as Raj's notification reader: authored formatting, no executable or remote content.
const allowed = new Set(["B", "BLOCKQUOTE", "BR", "CODE", "DIV", "EM", "H1", "H2", "H3", "LI", "OL", "P", "S", "SPAN", "STRIKE", "STRONG", "TABLE", "TBODY", "TD", "TH", "THEAD", "TR", "U", "UL"]);

export function safeNotificationHtml(value: string, rich = false): string {
  const document = new DOMParser().parseFromString(value || "", "text/html");
  document.body.querySelectorAll("script,style,iframe,object,embed,form,input,button,textarea,select,meta,link,base,svg,math").forEach(function (element) { element.remove(); });
  document.body.querySelectorAll("*").forEach(function (element) {
    if (!allowed.has(element.tagName) && !(rich && ["A", "IMG"].includes(element.tagName))) {
      element.replaceWith(...Array.from(element.childNodes));
      return;
    }
    const alignment = (element as HTMLElement).style.textAlign;
    const urlAttribute = element.tagName === "A" ? "href" : element.tagName === "IMG" ? "src" : "";
    const url = urlAttribute ? element.getAttribute(urlAttribute) : null;
    Array.from(element.attributes).forEach(function (attribute) { element.removeAttribute(attribute.name); });
    if (["left", "right", "center", "justify", "start", "end"].includes(alignment)) (element as HTMLElement).style.textAlign = alignment;
    if (url) {
      try {
        const parsed = new URL(url, window.location.origin);
        if (["http:", "https:", ...(urlAttribute === "href" ? ["mailto:"] : [])].includes(parsed.protocol)) {
          element.setAttribute(urlAttribute, url);
          if (urlAttribute === "href") { element.setAttribute("rel", "noopener noreferrer"); element.setAttribute("target", "_blank"); }
        }
      } catch { /* Drop malformed URLs. */ }
    }
  });
  return document.body.innerHTML;
}

export function notificationText(value: string): string {
  return new DOMParser().parseFromString(safeNotificationHtml(value), "text/html").body.textContent || "";
}

export function normalizeSearch(value: string): string {
  return value.replace(/ي/g, "ی").replace(/ك/g, "ک").replace(/\u200c/g, " ").trim().toLocaleLowerCase();
}
